import { CourseForm } from './CourseForm';

export type { CourseFormProps } from './CourseForm';

export default CourseForm;
